document.addEventListener('DOMContentLoaded', function() {

      // Get a reference to the dropdown button element
      const dropdownButton = document.getElementById('pvx-roi-dropbtn');
      const buttons = document.querySelectorAll('.pvx-roi-currency-option');
      const selectedOption = document.getElementById('pvx-roi-selected-option');

      const currencySymbol = document.querySelectorAll('.pvx-roi-currency-symbol');

      const currentCurrency = '£';
      const conversionRate = '1';

      const pluginDir =  document.getElementById("pvx-roi-currency-dropdown").dataset.pluginDir;

      // Image element to switch
      const currencyFlagImg = document.getElementById('active-currency-flag');

      // Get all the range sliders
      const rangeSliders = document.querySelectorAll('.range-slider__range');
  
      // Get the result elements
      const labourSavingsResult = document.querySelector('.calculator-result-item__result.labour-savings-result');
      const annualLossResult = document.querySelector('.calculator-result-item__result.annual-loss-result');
      const totalSavingsResult = document.querySelector('.calculator-result-item__result.total-savings-result');
      const roiResult = document.querySelector('.calculator-result-item__result.roi-result');


    // Function to toggle the dropdown menu
    function toggleDropdown() {
        document.getElementById("pvx-roi-dropdown-content").classList.toggle("show");
        document.getElementById("pvx-roi-dropdown-arrow").classList.toggle("show");
        document.getElementById("pvx-roi-currency-dropdown").classList.toggle("show");
    }

    dropdownButton.addEventListener('click', toggleDropdown);

    // Add click event listener to each button
    buttons.forEach(button => {
        button.addEventListener('click', function() {
            buttons.forEach(element => {
              element.removeAttribute('data-selected');
            });
            this.setAttribute('data-selected', 'selected');

            // Update selected currency
            const currency = this.getAttribute('data-currency');
            selectedOption.textContent = currency;
            
            // Update switch capability for image element
            updateFlagImage(currency);
            
            // Hide dropdown after selection
            document.getElementById("pvx-roi-dropdown-content").classList.toggle("show");
            document.getElementById("pvx-roi-dropdown-arrow").classList.toggle("show");
            document.getElementById("pvx-roi-currency-dropdown").classList.toggle("show");

            // Get conversion rate from selected element
            const conversionRate = this.getAttribute('value');
    
            // Get data label from selected attribute
            const currencyLabel = this.getAttribute('data-label');
            currencySymbol.forEach(currentCurrencyElement => {
              currentCurrencyElement.textContent = currencyLabel;
            });
    
            // Call the function to update the results
            updateResults(currencyLabel, conversionRate);
        });
    });

    // Function to update switch capability for image element
    function updateFlagImage(currency) {
      // Update src attribute based on currency
      const flagSrc = `${pluginDir}assets/icons/circle-flags_${currency.toLowerCase()}.svg`;
      currencyFlagImg.src = flagSrc;

      // Update alt attribute based on currency
      switch (currency) {
          case 'GBP':
              currencyFlagImg.alt = 'United Kingdom flag circle icon';
              break;
          case 'USD':
              currencyFlagImg.alt = 'United States flag circle icon';
              break;
          case 'AUD':
              currencyFlagImg.alt = 'Australian flag circle icon';
              break;
          default:
              // Handle other currencies if needed
              break;
        }
    }


        // Function to calculate and update the results
        function updateResults(currentCurrency, conversionRate) {
          const staffNumber = document.querySelector('.range-slider__range.staff-number').value;
          const ordersShipped = document.querySelector('.range-slider__range.orders-shipped').value;
          const orderValue = document.querySelector('.range-slider__range.order-value').value;
          const shippingErrors = document.querySelector('.range-slider__range.shipping-errors').value;
    
          var labourSavings = (staffNumber * 22000) * 0.2;
          var annualLoss = (orderValue * shippingErrors) * 365;
          var totalSavings = annualLoss + labourSavings;
  
          var pvxCost;
  
          // Calculate pvxCost based on ordersShipped ranges
          if (ordersShipped >= 0 && ordersShipped <= 100) {
            pvxCost = 15000;
          } else if (ordersShipped >= 101 && ordersShipped <= 500) {
            pvxCost = 30000;
          } else if (ordersShipped >= 501 && ordersShipped <= 1000) {
            pvxCost = 42000;
          } else {
            pvxCost = 54000;
          }
  
          const pvxCostConverted = pvxCost * conversionRate;
  
          var roi = totalSavings / pvxCostConverted;
    
          labourSavingsResult.textContent = currentCurrency + labourSavings.toLocaleString("en-US");
          annualLossResult.textContent = currentCurrency + annualLoss.toLocaleString("en-US");
          totalSavingsResult.textContent = currentCurrency + totalSavings.toLocaleString("en-US");
          roiResult.textContent = Math.round(roi).toLocaleString("en-US") + 'x';
      }
    
      // Loop through each range slider
      rangeSliders.forEach(function(rangeInput) {
        const valueSpan = rangeInput.parentNode.querySelector('.range-slider__value');
    
        // Calculate the percentage value based on the initial value
        const percentage = (rangeInput.value - rangeInput.min) / (rangeInput.max - rangeInput.min) * 100;
    
        // Set the initial background size + value
        rangeInput.style.backgroundSize = `${percentage}% 100%`;
        valueSpan.textContent = rangeInput.value;
    
        // Update the value of the span and range input when the user slides the range scale
        rangeInput.addEventListener('input', function() {
          // Update the value of the span
          valueSpan.textContent = this.value;
    
          // Calculate the percentage value
          const percentage = (this.value - this.min) / (this.max - this.min) * 100;
    
          // Update the background size
          this.style.backgroundSize = `${percentage}% 100%`;
    
          // Call the function to update the results
          updateResults(currentCurrency, conversionRate);
        });
    
        // Update the value of the range input when the user changes the value manually
        valueSpan.addEventListener('input', function() {
          // Update the value of the range input
          rangeInput.value = this.textContent;
    
          // Calculate the percentage value
          const percentage = (rangeInput.value - rangeInput.min) / (rangeInput.max - rangeInput.min) * 100;
    
          // Update the background size
          rangeInput.style.backgroundSize = `${percentage}% 100%`;
    
          // Call the function to update the results
          updateResults(currentCurrency, conversionRate);
        });
      });
    
      // Call the function initially to calculate and update the results
      updateResults(currentCurrency, conversionRate);
    });
     
